document.addEventListener("DOMContentLoaded", () => {
  const productSwatchOptions = document.querySelectorAll(
    ".swatch-option-value"
  );
  let atcFormVariantInput = document.getElementById(
    "main-product-atc__variant-id"
  );
  let quantityInput = document.getElementById("quantity-input");

  let totalQuantityCount = document.querySelector(".total-quantity-count");
  let totalQuantityText = document.querySelector(".total-quantity-text");
  let totalCalculation = document.querySelector(".total-calculation");
  const productForm = document.querySelector("form[action='/cart/add']");
  const productVariants = JSON.parse(
    document.getElementById("product-variants-json").textContent
  );
  const productTitle = document.querySelector(
    ".main-product-information__title"
  ).innerText;
  const isMultiPack = productTitle.includes("Pack of") || productTitle.includes("Pallet of");
  const packSize = isMultiPack
    ? parseInt(productTitle.match(/pack of (\d+)/i)?.[1]) || parseInt(productTitle.match(/pallet of (\d+)/i)?.[1])
    : 1;

  // Bundle inventory management
  let currentBundleInventory = null;
  let currentBundleSize = 1;
  const bundleMetafields = JSON.parse(
    document.getElementById("bundle-metafields-json")?.textContent || "{}"
  );

  // Check if current variant is a bundle and calculate inventory
  function checkBundleInventory(variant) {
    // Reset bundle state
    currentBundleInventory = null;
    currentBundleSize = 1;

    // Check for bundle metafields in JSON
    const bundleData = bundleMetafields[variant.id];
    
    if (bundleData && bundleData.bundleInventory !== null && bundleData.bundleQuantity !== null) {
      currentBundleInventory = bundleData.bundleInventory;
      currentBundleSize = parseInt(bundleData.bundleQuantity);
      
      const maxBundles = Math.floor(currentBundleInventory / currentBundleSize);
      
      return {
        isBundle: true,
        maxQuantity: maxBundles,
        available: currentBundleInventory >= currentBundleSize
      };
    }

    // Not a bundle (or missing required data)
    return {
      isBundle: false,
      maxQuantity: variant.inventory_quantity || 999,
      available: variant.available
    };
  }

  function updateSwatchAvailability() {
    const activeOptions = {};
    document
      .querySelectorAll(".swatch-option-value.active")
      .forEach((activeElement) => {
        const optionName = activeElement.getAttribute("swatch-option-value");
        const optionValue = activeElement.getAttribute(
          "swatch-option-value-name"
        );
        activeOptions[optionName] = optionValue;
      });

    // console.log("Active Options:", activeOptions);
    // console.log("Product Variants:", productVariants);

    productSwatchOptions.forEach((option) => {
      const optionName = option.getAttribute("swatch-option-value");
      const optionValue = option.getAttribute("swatch-option-value-name");

      const isOptionAvailable = productVariants.some((variant) => {
        if (variant.available !== true) {
          return false;
        }
        const variantMatch = { ...activeOptions, [optionName]: optionValue };
        return Object.entries(variantMatch).every(([key, value]) =>
          variant.options.includes(value)
        );
      });

      //   console.log(
      //     `Checking availability for ${optionName}: ${optionValue}`,
      //     isOptionAvailable
      //   );

      if (isOptionAvailable) {
        option.classList.remove("disabled");
        option.removeAttribute("disabled");
      } else {
        option.classList.add("disabled");
        option.setAttribute("disabled", "true");
      }
    });
  }

  function updateTotalQuantityOnLoad() {
    updateTotalQuantityAndText(parseInt(quantityInput.value), packSize);
  }

  const setPrice = (amount, vat_price) => {
    const priceSettings = document.querySelector(
      ".main-product__price"
    ).dataset;

    const price =
      priceSettings.currencyIncVat === "true"
        ? (amount / 100).toFixed(2)
        : ((amount * 80) / 10000).toFixed(2);

    return priceSettings.currencySymbol + price;
  };

  // Bulk pricing functionality
  const BulkPricing = {
    getPriceForQuantity(quantity) {
      const priceContainer = document.querySelector(".main-product__price");
      if (!priceContainer) return null;

      const quantities = JSON.parse(priceContainer.dataset.breakdownQuantities || '[]');
      const prices = JSON.parse(priceContainer.dataset.breakdownPrices || '[]');
      const basePrice = parseInt(priceContainer.dataset.basePrice);

      // Find the applicable price tier
      let applicablePrice = basePrice;
      for (let i = quantities.length - 1; i >= 0; i--) {
        if (quantity >= parseInt(quantities[i])) {
          applicablePrice = Math.round(parseFloat(prices[i]) * 100);
          break;
        }
      }
      return applicablePrice;
    },

    updateDisplay(price) {
      const regularPrice = document.querySelector(".main-product__price .regular-price");
      const discountedPrice = document.querySelector(".main-product__price .discounted-price");

      [regularPrice, discountedPrice].forEach(element => {
        if (element) {
          element.innerText = setPrice(price);
          delete element.dataset.originalPrice; // Clear for VAT toggle
        }
      });

      // Trigger VAT recalculation
      const vatToggle = document.querySelector('vat-toggle');
      if (vatToggle && vatToggle._renderPrices) {
        setTimeout(() => vatToggle._renderPrices(), 10);
      }
    }
  };

  const updatePriceBasedOnQuantity = () => {
    if (!quantityInput) return;
    
    const quantity = parseInt(quantityInput.value);
    const newPrice = BulkPricing.getPriceForQuantity(quantity);
    if (newPrice) {
      BulkPricing.updateDisplay(newPrice);
    }
  };

  const updateVariantPrice = (variant) => {
    // Keep original global selectors for variant price updates
    let regularPriceLabel = document.querySelector(".regular-price");
    let discountedPriceLabel = document.querySelector(".discounted-price");
    let originalPriceLabel = document.querySelector(".original-price");

    // Update base price for the new variant (only on product page)
    const priceContainer = document.querySelector(".main-product__price");
    if (priceContainer) {
      priceContainer.dataset.basePrice = variant.price;
    }

    if (regularPriceLabel)
      regularPriceLabel.innerText = setPrice(variant.price);

    if (discountedPriceLabel)
      discountedPriceLabel.innerText = setPrice(variant.price);

    if (originalPriceLabel && variant.compare_at_price) {
      originalPriceLabel.classList.remove("hidden");
      originalPriceLabel.innerText = setPrice(variant.compare_at_price);
    } else if (originalPriceLabel) {
      originalPriceLabel.classList.add("hidden");
    }

    // Update price based on current quantity (only affects product page)
    updatePriceBasedOnQuantity();
  };

  const updateVariantSku = (variant) => {
    const skuElement = document.querySelector(".product-sku");
    if (skuElement) {
      skuElement.innerText = variant.sku || "";
    }
  };

  const updateVariantId = () => {
    const activeOptions = {};
    document
      .querySelectorAll(".swatch-option-value.active")
      .forEach((activeElement) => {
        const optionName = activeElement.getAttribute("swatch-option-value");
        const optionValue = activeElement.getAttribute(
          "swatch-option-value-name"
        );
        activeOptions[optionName] = optionValue;
      });

    for (const variant of productVariants) {
      if (
        variant.available &&
        Object.entries(activeOptions).every(([optionName, optionValue]) =>
          variant.options.includes(optionValue)
        )
      ) {
        atcFormVariantInput.value = variant.id;

        updateVariantPrice(variant);
        updateVariantSku(variant);
        
        // Update main image to variant image if it exists
        updateMainImageForVariant(variant);
        
        // Only run bundle logic if current variant has required bundle metafields; otherwise, do not touch PDP stock handling
        const bundleData = bundleMetafields[variant.id];
        const hasVariantBundleMetafields = !!(bundleData && bundleData.bundleInventory !== null && bundleData.bundleQuantity !== null);
        if (hasVariantBundleMetafields) {
          const bundleInfo = checkBundleInventory(variant);
          updateBundleUI(bundleInfo);
        }
        
        break;
      }
    }
  };

  // Update UI based on bundle inventory
  function updateBundleUI(bundleInfo) {
    const submitButton = document.querySelector("#main-product-atc");
    const stockStatusElement = document.querySelector(".main-product__stock-status__stock-text");
    
    // Update max quantity on input
    if (quantityInput) {
      quantityInput.setAttribute("max", bundleInfo.maxQuantity);
      
      // Reset quantity to 1 if current value exceeds max
      if (parseInt(quantityInput.value) > bundleInfo.maxQuantity) {
        quantityInput.value = 1;
        updateTotalQuantityAndText(1, packSize);
      }
    }
    
    // Update ATC button state
    if (submitButton) {
      const isOutOfStock = !bundleInfo.available || bundleInfo.maxQuantity === 0;
      const disabledClasses = ["opacity-70", "cursor-not-allowed", "pointer-events-none"];
      
      submitButton.disabled = isOutOfStock;
      submitButton.value = isOutOfStock ? "Out of Stock" : "Add to Basket";
      submitButton.classList[isOutOfStock ? "add" : "remove"](...disabledClasses);
    }
    
    // Update stock status display
    if (stockStatusElement) {
      if (bundleInfo.isBundle) {
        // Bundle-specific stock status
        if (bundleInfo.available && bundleInfo.maxQuantity > 0) {
          stockStatusElement.innerHTML = `
            <div class="bg-[#BFE9CB] size-[9px] rounded-full flex justify-center items-center">
              <div class="bg-[#0FB23C] size-[5px] rounded-full"></div>
            </div>
            <span>Item In Stock</span>
          `;
          stockStatusElement.classList.remove("text-red-500");
          stockStatusElement.classList.add("text-[#0FB23C]");
        } else {
          stockStatusElement.innerHTML = `
            <div class="bg-red-200 size-[9px] rounded-full flex justify-center items-center">
              <div class="bg-red-500 size-[5px] rounded-full"></div>
            </div>
            <span>Out of Stock</span>
          `;
          stockStatusElement.classList.remove("text-[#0FB23C]");
          stockStatusElement.classList.add("text-red-500");
        }
      } else {
        // Non-bundle: reset to default state (based on variant availability)
        if (bundleInfo.available) {
          stockStatusElement.innerHTML = `
            <div class="bg-[#BFE9CB] size-[9px] rounded-full flex justify-center items-center">
              <div class="bg-[#0FB23C] size-[5px] rounded-full"></div>
            </div>
            <span>Item In Stock</span>
          `;
          stockStatusElement.classList.remove("text-red-500");
          stockStatusElement.classList.add("text-[#0FB23C]");
        } else {
          stockStatusElement.innerHTML = `
            <div class="bg-red-200 size-[9px] rounded-full flex justify-center items-center">
              <div class="bg-red-500 size-[5px] rounded-full"></div>
            </div>
            <span>Out of Stock</span>
          `;
          stockStatusElement.classList.remove("text-[#0FB23C]");
          stockStatusElement.classList.add("text-red-500");
        }
      }
    }
  }
  
  const updateMainImageForVariant = (variant) => {
    // Check if variant has a featured image
    if (variant.featured_image && variant.featured_image.position) {
      // Get the swiper instance
      const swiperElement = document.querySelector('.main-product__swiper');
      
      if (swiperElement && swiperElement.swiper) {
        // Slide to the variant image position (position is 1-indexed, swiper is 0-indexed)
        const slideIndex = variant.featured_image.position - 1;
        swiperElement.swiper.slideTo(slideIndex);
      }
    }
  };

  productSwatchOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      if (option.hasAttribute("disabled")) return;

      const targetOption = e.currentTarget;
      const optionName = targetOption.getAttribute("swatch-option-value");

      productSwatchOptions.forEach((opt) => {
        if (opt.getAttribute("swatch-option-value") === optionName) {
          opt.classList.remove("active");
        }
      });
      targetOption.classList.add("active");

      const selectedValueElement = document.querySelector(
        `.product-swatch-option__${optionName}-selected-value`
      );
      if (selectedValueElement) {
        selectedValueElement.innerText = targetOption.getAttribute(
          "swatch-option-value-name"
        );
      }

      if (optionName === "pack-size") {
        updateTotalQuantityAndText(
          parseInt(quantityInput.value),
          parseInt(
            targetOption.getAttribute("swatch-option-value-name").split(" ")[0]
          )
        );
      }

      updateVariantId();
      updateSwatchAvailability();
    });
  });

  quantityInput.addEventListener("input", function () {
    updateTotalQuantityAndText(parseInt(quantityInput.value), packSize);
    updatePriceBasedOnQuantity();
  });

  function updateTotalQuantityAndText(quantity, packSize) {
    const total = quantity * packSize;
    totalQuantityCount.innerText = total;

    const quantityTextParts = totalCalculation
      .getAttribute("quantity-text")
      .split("-");
    const updatedText =
      total === 1 ? quantityTextParts[0].trim() : quantityTextParts[1].trim();

    totalQuantityText.innerText = updatedText;
  }

  window.increaseQuantity = function () {
    const currentValue = parseInt(quantityInput.value);
    const max = parseInt(quantityInput.getAttribute("max"));

    if (!isNaN(max) && currentValue < max) {
      quantityInput.value = currentValue + 1;
      triggerQuantityChange();
    } else if (isNaN(max)) {
      // No max limit set
      quantityInput.value = currentValue + 1;
      triggerQuantityChange();
    }
  };

  window.decreaseQuantity = function () {
    const currentValue = parseInt(quantityInput.value);
    const min = parseInt(quantityInput.getAttribute("min"));

    if (currentValue > min) {
      quantityInput.value = currentValue - 1;
      triggerQuantityChange();
    }
  };

  function triggerQuantityChange() {
    updateTotalQuantityAndText(parseInt(quantityInput.value), packSize);
    updatePriceBasedOnQuantity();
  }

  productForm.addEventListener("submit", (e) => {
    e.preventDefault();
    const variantId = atcFormVariantInput.value;
    const quantity = parseInt(quantityInput.value);

    addToCart({ variantId, quantity });
  });

  // Initial calculation and availability check on load
  updateTotalQuantityOnLoad();
  updateVariantId();
  updateSwatchAvailability();
  
  // Update price on load if bulk pricing exists
  if (quantityInput) {
    updatePriceBasedOnQuantity();
  }
});
